import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

/**
 * To use in a template, add [@dfSlideFadeInLeft] trigger
 * to an html element controlled by an *ngIf or *ngFor statement
 * Fade in is triggered when the element is added to the template
 */
export const DF_SLIDE_FADE_IN_LEFT = trigger('dfSlideFadeInLeft', [
  transition(':enter', [
    style({ opacity: 0, left: '100px' }),
    animate('300ms ease-in', style({ opacity: 1, left: '*' })),
  ]),
]);

/**
 * To use in a template, add [@dfCollapseExpand] trigger
 * to an html element controlled by an *ngIf or *ngFor statement.
 * Collapse animation is triggered before removal of the element
 * and expanded when the element added to the template
 */
export const DF_COLLAPSE_EXPAND = trigger('dfCollapseExpand', [
  state('void', style({ height: '0px', opacity: '0' })),
  state('*', style({ height: '*', opacity: '1' })),
  transition('void <=> *', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
]);
